export default __webpack_public_path__ + "static/media/main-characters-padded-sm-1x.781f24e1.jpg";